import React, { useEffect, useState } from 'react';
import { ConnectedWallet } from '../../../assets/constant/kit.type';
import { Account } from '../../../assets/constant/accountManager.type';
import ModalTemplateB from '../../../components/_template/modal/ModalTemplateB';
import PageLoading from '../../../components/_atom/loading/PageLoading';
import SelectAccount from './SelectAccount';

type GetAddressOfAccountModalProps = {
  isOpen: boolean;
  closeModal: (connectedWallet?: ConnectedWallet) => void;
  setAddress: (address: string) => void;
  kitOwnerAddress?: string;
};
const GetAddressOfAccountModal = (props: GetAddressOfAccountModalProps) => {
  const { isOpen, closeModal, setAddress, kitOwnerAddress } = props;
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(false);
  }, [isOpen]);

  return (
    <ModalTemplateB isOpen={isOpen} title={'Select Account'} showDivideLine={false} onRequestClose={closeModal as any}>
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        >
          <PageLoading style={{ height: 246 }} />
        </div>
      )}
      <SelectAccount onClickSelect={(account: Account) => setAddress(account.address || '')} kitOwnerAddress={kitOwnerAddress} onClosed={closeModal} />
    </ModalTemplateB>
  );
};

export default GetAddressOfAccountModal;
